import React from 'react'
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
import ChinaBloreMain from './ChinaBloreMain';
const ChinaBlore = () => {
  return (
    <div className="uaeBloreContainer">
    <UaeBloreHead head="China Attestation in Bangalore" />
    <ChinaBloreMain />
    </div>
  )
}

export default ChinaBlore
